import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-gallery').each((index, gallery) => {
  const $gallery = $(gallery);
  const $galleryContainer = $gallery.find('.js-gallery-container');

  $galleryContainer.flickity({
    contain: true,
    draggable: true,
    lazyLoad: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
  });
});
